import React from "react";
import styles from "./newModal.module.scss";
import { ReferalServices } from "../../../services/referal.service";
import { setCookie } from "../../../utils/utils";
import { useDispatch } from "react-redux";
import { fetchUser } from "../../../redux/Slices/userProfile";
import { AppDispatch } from "../../../redux/store";
import close from "../../../assets/images/referal/Close Icon.svg";
import { setMainAccount, setRefresh } from "../../../redux/Slices/referalMainAcc";
import { toast } from "react-toastify";
interface ModalProps {
  title: string;
  content: string | React.ReactNode;
  onClose: () => void;
  confirmText?: string;
  cancelText?: string;
  musteriId?: number;
  setShowModal: (value: boolean) => void;
  setLoading: (value: boolean) => void;
}

const NewModal: React.FC<ModalProps> = ({
  title,
  content,
  onClose,
  confirmText = "Qəbul et",
  cancelText = "Sil",
  musteriId,
  setShowModal,
  setLoading,
}) => {
  const dispatch = useDispatch<AppDispatch>();

  const handleConfirm = async () => {
    setLoading(true);
    try {
      const response = await ReferalServices.PostRedirectReferalAccount({
        referalId: musteriId,
      });

      if (response.data.original.token) {
        setCookie("ColibriToken", response.data.original.token, 14);
        dispatch(fetchUser());
        setShowModal(false);
        dispatch(setMainAccount(true));
        dispatch(setRefresh(true));
      }
    } catch (error: any) {
      toast.error(error.original.content);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className={styles.background} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <h3>{title}</h3>
        <div className={styles.modalBody}>{content}</div>
        <div className={styles.buttonContainer}>
          <button className={styles.cancelBtn} onClick={onClose}>
            {cancelText}
          </button>
          <button className={styles.confirmBtn} onClick={handleConfirm}>
            {confirmText}
          </button>
        </div>
        <button onClick={onClose} className={styles.closeBtn}>
          <img src={close} alt="x" />
        </button>
      </div>
    </div>
  );
};

export default NewModal;
